// node-modules
import Barba from 'barba.js/dist/barba';
import PubSub from 'pubsub-js';
import { TweenLite } from 'gsap/TweenLite';

// constants
import { EVENTS } from '@/scripts/constants';

// others
import { initPlugins, destroyPlugins } from '@/scripts/plugins/index';


export default Barba.BaseTransition.extend({
  start() {
    Promise
      .all([this.fadeOut.call(this), this.newContainerLoading, this.fakeTimeout.call(this)])
      .then(this.fadeIn.bind(this));
  },

  fakeTimeout() {
    return new Promise((resolve) => {
      setTimeout(() => resolve(true), 2000);
    });
  },

  fadeOutAnimation() {
    return new Promise((resolve) => {
      TweenLite.to(this.oldContainer, 1, {
        autoAlpha: 0,
        onComplete() {
          resolve(true);
        },
      });
    });
  },

  fadeOut() {
    return new Promise(async (resolve) => {
      const timeout = await Promise.all([
        this.fadeOutAnimation(),
        destroyPlugins(),
      ]);
      if (timeout) {
        resolve(true);
      }
    });
  },

  async fadeIn() {
    TweenLite.set(window, { scrollTo: { y: 0, autoKill: false } });
    TweenLite.set(this.newContainer, { opacity: 0 });
    this.done();

    const timeout = [
      await initPlugins(this.newContainer, true),
    ];

    if (timeout) {
      requestIdleCallback(() => {
        TweenLite.fromTo(this.newContainer, 1, { autoAlpha: 0 }, {
          autoAlpha: 1,
          onComplete: () => {
            PubSub.publish(EVENTS.preloaderEnd);
            PubSub.publish(EVENTS.loadingEnd);
          },
        });
      }, { timeout: 1000 });
    }
  },
});



// WEBPACK FOOTER //
// ./components/PageNavigation/transition.js